import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { uniqueId } from "lodash-es";
import { useState, useMemo, useCallback, useEffect, useRef } from "react";
import dropDownIcon from "../../images/dropdown-button.svg";
import { Collapse } from "react-collapse";
import SingleLocation from "./single-location";
import { useDebounce } from 'use-debounce';
export default function LocationDropdown(props) {
    const { locations, placeholder, onChange, value } = props;
    const collpaseId = useMemo(() => uniqueId("location-dropdown-collapse"), []);
    const [isOpen, setIsOpen] = useState(false);
    const [filterRegionsText, setFilterRegionsText] = useState("");
    const [regions, setRegions] = useState([]);
    const [locationOpen, setLocationOpen] = useState("");
    const componentRef = useRef(null);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const locationInput = document.querySelector('.range-dropdown-trigger input');
    const locationInputMobile = document.querySelector('.filters-mobile-sidebar .location-dropdown .range-dropdown-trigger input');
    const [debouncedSearch] = useDebounce(filterRegionsText, 200);
    const collapseHandler = useCallback((event) => {
        if (componentRef.current && !componentRef.current.contains(event.target) && isOpen) {
            setIsOpen(false);
        }
    }, [isOpen, setIsOpen, componentRef]);
    useEffect(() => {
        document.addEventListener('mousedown', collapseHandler);
        return () => document.removeEventListener('mousedown', collapseHandler);
    }, [collapseHandler]);
    useEffect(() => {
        (async () => {
            const url = `/wp-json/macleod/v1/regions?search=${filterRegionsText}`;
            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                    },
                });
                if (!response.ok) {
                    throw new Error('HTTP status ' + response.status);
                }
                const result = await response.json();
                setRegions(result);
            }
            catch (error) {
                console.error(error);
            }
        })();
    }, []);
    const handleClick = useCallback(() => {
        setIsOpen((isOpen) => !isOpen);
    }, [setIsOpen]);
    const handleFilterTextChange = (event) => {
        setFilterRegionsText(event.target.value);
        setIsOpen(event.target.value.length > 0);
    };
    return (_jsxs("div", { className: "range-dropdown location-dropdown", ref: componentRef, children: [_jsxs("button", { className: "range-dropdown-trigger", "aria-controls": collpaseId, "aria-haspopup": "true", children: [_jsx("input", { type: "text", className: "location-dropdown-trigger", placeholder: placeholder, value: filterRegionsText, onChange: handleFilterTextChange }), _jsx("img", { src: dropDownIcon, alt: "", onClick: handleClick })] }), _jsx(Collapse, { id: collpaseId, isOpened: isOpen, children: locations.map((location, index) => {
                    if (location.search && filterRegionsText && !location.search.includes(filterRegionsText.toLowerCase())) {
                        return null;
                    }
                    return (_jsx(SingleLocation, { location: location, onChange: onChange, value: value, filterRegionsText: filterRegionsText, locationOpen: locationOpen, setLocationOpen: setLocationOpen, selectedLocations: selectedLocations, setSelectedLocations: setSelectedLocations, locationInput: locationInput, locationInputMobile: locationInputMobile }, index));
                }) })] }));
}
